import {NavLink} from 'react-router-dom'
import {NewItem} from './NewsItem'
import st from './News.module.scss'
import newsBg from 'assets/images/news-bg.png'
import newsBgM from 'assets/images/news-bg-m.png'
import arrow from 'assets/images/svg/arrow-icon-lf.svg'
import {useAppContext} from 'Context'
import {Spinner} from 'components/Spinner/Spinner'
import {Pagination} from '../../../components/Pagination/Pagination';
import {useNews} from '../../../helpers';

export const NewsAll = ()=> {
    const { region } = useAppContext()
    const { data, isLoading, meta }  = useNews(region.id, 18)
    const cn = st.news+' '+st.news_all + ' ' +(!data ? st.news_pre_load : '' )
    const cnLoad = st.list+' '+(isLoading ? st.list_load : '')

    return (
        <section className={cn}>

            <div className={st.bg}>
                <picture>
                    <source media='(max-width: 400px)' srcSet={newsBgM} />
                    <img src={newsBg} alt="" width={100} height={100} />
                </picture>
            </div>

            <div className="wrapper">
                <div >
                    <div className={st.head}>
                        <NavLink to="/" className={st.link}>
                            <img src={arrow} alt="" width={24} height={24} />
                            <span>Назад</span>
                        </NavLink>
                        <h2 className={st.title}>новости</h2>
                    </div>

                    <div className={cnLoad} style={{ minHeight: '30vh' }}>
                        {isLoading && <div className={st.loader}><Spinner cn={st.spin} /></div>}

                        {data && data?.map(news => <NewItem data={news} key={news.id} />)}
                    </div>

                    {meta &&
                        <Pagination meta={meta} />
                    }
                </div>
            </div>
        </section>
    )
}
